import React from 'react';

export default function FinalCTASection() {
  const scrollToGetInTouch = () => {
    const element = document.getElementById('get-in-touch');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-amber-500 py-12 lg:py-16 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4xKSIvPjwvc3ZnPg==')] z-0"></div>
      
      {/* Decorative Circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-400 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse z-0 transform translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-600 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse z-0 transform -translate-x-1/2 translate-y-1/2"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
        
        {/* Text Content */}
        <div className="text-center lg:text-left max-w-2xl">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight mb-3 uppercase">
            Ready to Transform <br className="hidden lg:block" /> Your Digital Future?
          </h2>
          <p className="text-gray-900 text-base sm:text-lg font-medium mb-0 opacity-90">
            Let's discuss how GarudStacks can engineer the perfect solution for your enterprise.
          </p>
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 flex-shrink-0">
          <button
            onClick={scrollToGetInTouch}
            className="w-full sm:w-auto px-8 py-4 bg-gray-900 text-white font-bold uppercase tracking-widest text-sm rounded-xl hover:bg-black hover:-translate-y-1 transition-all duration-300 shadow-xl flex items-center justify-center gap-3 cursor-pointer"
          >
            Schedule a Call
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </button>
          <a
            href="/contact"
            className="w-full sm:w-auto px-8 py-4 bg-white/20 hover:bg-white text-gray-900 font-bold uppercase tracking-widest text-sm rounded-xl border border-gray-900/20 hover:border-white transition-all duration-300 flex items-center justify-center"
          >
            Contact Sales
          </a>
        </div>
        
      </div>
    </section>
  );
}
